import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Collection from "@/pages/Collection";
import ProductDetail from "@/pages/ProductDetail";
import House from "@/pages/House";
import Journal from "@/pages/Journal";
import JournalArticle from "@/pages/JournalArticle";
import Contact from "@/pages/Contact";
import Rituals from "@/pages/Rituals";
import RitualEntry from "@/pages/RitualEntry";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/collection" element={<Collection />} />
            <Route path="/collection/:slug" element={<ProductDetail />} />
            <Route path="/rituals" element={<Rituals />} />
            <Route path="/rituals/:slug" element={<RitualEntry />} />
            <Route path="/house" element={<House />} />
            <Route path="/journal" element={<Journal />} />
            <Route path="/journal/:slug" element={<JournalArticle />} />
            <Route path="/contact" element={<Contact />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: "hsl(30 10% 8%)",
            color: "hsl(39 30% 89%)",
            border: "none",
            borderRadius: 0,
            fontFamily: "'Inter Tight', sans-serif",
            fontSize: 12,
            letterSpacing: "0.12em",
            textTransform: "uppercase",
          },
        }}
      />
    </div>
  );
}

export default App;
